import { DealXgSocketActions } from './dealXgSocketActionTypes';
import { DealXgTopic } from '@makemydeal/dr-shared-types/constants/dealXgTopics';
import type { SocketEventPayload } from '@makemydeal/dr-shared-bff-types';

const DEAL_CHANGE_TOPICS: readonly string[] = [DealXgTopic.DEAL_XG_CREATE, DealXgTopic.DEAL_XG_PATCH];

export const processSocketEvent = (payload: SocketEventPayload) => {
    const persona = payload?.data?.changedBy?.persona;
    const topic = payload?.topic;
    const isDealChangeEvent = !!topic && DEAL_CHANGE_TOPICS.includes(topic);

    if (!persona || !isDealChangeEvent) {
        return {
            type: DealXgSocketActions.SOCKET_EVENT_IGNORED,
            payload
        };
    }
    return {
        type: DealXgSocketActions.SOCKET_EVENT_RECEIVED,
        payload
    };
};
